/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Not_On_RosterInputs */

const th_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้เล่นคนนี้ไม่ได้อยู่ในทีมนี้`)
};

const en_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That player is not on this roster.`)
};

const ja_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この選手はこのロースターにいません。`)
};

const zh_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该球员不在此阵容中。`)
};

const es_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese jugador no está en esta plantilla.`)
};

const pt_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse jogador não está neste elenco.`)
};

const id_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain itu tidak ada di skuad ini.`)
};

const fr_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce joueur n’est pas dans cet effectif.`)
};

const tl_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala sa squad na ito ang manlalarong iyon.`)
};

const vi_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cầu thủ đó không có trong đội hình này.`)
};

const ko_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그 선수는 이 선수단에 없습니다.`)
};

const de_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Spieler steht nicht in diesem Kader.`)
};

const ru_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этого игрока нет в данном составе.`)
};

const tr_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O oyuncu bu kadroda değil.`)
};

const it_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel giocatore non è in questa rosa.`)
};

const pl_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tego zawodnika nie ma w tym składzie.`)
};

const uk_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цього гравця немає в цьому складі.`)
};

const hi_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वह खिलाड़ी इस टीम में नहीं है।`)
};

const ar_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذلك اللاعب ليس في هذه التشكيلة.`)
};

const ms_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemain itu tiada dalam skuad ini.`)
};

const bn_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ওই খেলোয়াড় এই দলে নেই।`)
};

const zh_tw2_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那位球員不在這份名單中。`)
};

const zh_hk2_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`那位球員不在這份名單中。`)
};

const ur_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وہ کھلاڑی اس اسکواڈ میں نہیں۔`)
};

const fa_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آن بازیکن در این فهرست تیم نیست.`)
};

const sw_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mchezaji huyo hayupo kwenye kikosi hiki.`)
};

const nl_err_not_on_roster = /** @type {(inputs: Err_Not_On_RosterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die speler staat niet in deze selectie.`)
};

/**
* | output |
* | --- |
* | "That player is not on this roster." |
*
* @param {Err_Not_On_RosterInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_not_on_roster = /** @type {((inputs?: Err_Not_On_RosterInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Not_On_RosterInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_not_on_roster(inputs)
	if (locale === "ja") return ja_err_not_on_roster(inputs)
	if (locale === "zh") return zh_err_not_on_roster(inputs)
	if (locale === "es") return es_err_not_on_roster(inputs)
	if (locale === "pt") return pt_err_not_on_roster(inputs)
	if (locale === "id") return id_err_not_on_roster(inputs)
	if (locale === "fr") return fr_err_not_on_roster(inputs)
	if (locale === "tl") return tl_err_not_on_roster(inputs)
	if (locale === "vi") return vi_err_not_on_roster(inputs)
	if (locale === "ko") return ko_err_not_on_roster(inputs)
	if (locale === "de") return de_err_not_on_roster(inputs)
	if (locale === "ru") return ru_err_not_on_roster(inputs)
	if (locale === "tr") return tr_err_not_on_roster(inputs)
	if (locale === "it") return it_err_not_on_roster(inputs)
	if (locale === "pl") return pl_err_not_on_roster(inputs)
	if (locale === "uk") return uk_err_not_on_roster(inputs)
	if (locale === "hi") return hi_err_not_on_roster(inputs)
	if (locale === "ar") return ar_err_not_on_roster(inputs)
	if (locale === "ms") return ms_err_not_on_roster(inputs)
	if (locale === "bn") return bn_err_not_on_roster(inputs)
	if (locale === "zh-TW") return zh_tw2_err_not_on_roster(inputs)
	if (locale === "zh-HK") return zh_hk2_err_not_on_roster(inputs)
	if (locale === "ur") return ur_err_not_on_roster(inputs)
	if (locale === "fa") return fa_err_not_on_roster(inputs)
	if (locale === "sw") return sw_err_not_on_roster(inputs)
	if (locale === "nl") return nl_err_not_on_roster(inputs)
	return en_err_not_on_roster(inputs)
});